<template>
  <section class="headSection main-filter">
    <form
      @submit.prevent
      class="w-100 d-flex justify-content-between align-items-center flex-wrap"
    >
      <div class="frm-controls w-100 p-0">
        <div class="col-md-4" v-if="withSearch">
          <div class="input_wrapper top_label">
            <label for="searchInput" class="form-label">{{ "بحث عن" }}</label>
            <v-text-field
              id="searchInput"
              prepend-icon="mdi-magnify"
              v-model="frmData.searchInput"
              @input="setKeyWord($event, 'keyword'), getResult"
            ></v-text-field>
          </div>
        </div>
        <div
          class="categories col-sm-3 col-md-4"
          v-if="reportStatus.length && reportType == 'order'"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.report_status"
              :options="reportStatus"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              :allow-empty="false"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label"> الحالة </label>
          </div>
        </div>
        <div
          class="categories col-sm-3 col-md-4"
          v-if="reportStatus.length && reportType == 'cancel_order'"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.report_cancel_order_status"
              :options="cancelOrderStatus"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              :allow-empty="false"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label"> الحالة </label>
          </div>
        </div>
        <div
          class="categories col-sm-3 col-md-4"
          v-if="reportCancelOrderReasons.length && reportType == 'cancel_order'"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.report_cancel_order_reason"
              :options="reportCancelOrderReasons"
              label="name"
              track-by="id"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              :allow-empty="false"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label"> اسباب الالغاء </label>
          </div>
        </div>
        <div
          class="categories col-sm-3 col-md-4"
          v-if="order_types.length && reportType == 'Financial'"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.order_type"
              :options="order_types"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              :allow-empty="false"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label">
              {{ $t("forms.labels.orderType") }}
            </label>
          </div>
        </div>
        <div
          class="categories col-sm-3 col-md-4"
          v-if="
            userTypes.length &&
            (reportType == 'Debits' || reportType == 'Deposit')
          "
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.user_type"
              :options="userTypes"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              :allow-empty="false"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label">
              {{ $t("forms.labels.orderType") }}
            </label>
          </div>
        </div>
        <div
          class="categories col-sm-3 col-md-4"
          v-if="reportType == 'Financial'"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.order_status"
              :options="order_statuses"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label">
              {{ $t("forms.labels.status") }}
            </label>
          </div>
        </div>
        <div
          class="categories col-sm-3 col-md-4"
          v-if="reportType == 'Deposit'"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.deposit_type"
              :options="deposit_types"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label"> نوع الايداع </label>
          </div>
        </div>

        <div
          class="categories col-sm-3 col-md-4"
          v-if="reportType == 'Financial'"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.payment_type"
              :options="payment_types"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label">
              {{ $t("forms.labels.payment_type") }}
            </label>
          </div>
        </div>
        <div class="categories col-sm-3 col-md-4" v-if="reportType == 'Wallet'">
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.type"
              :options="types"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label"> النوع </label>
          </div>
        </div>
        <div class="categories col-sm-3 col-md-4" v-if="reportType == 'Wallet'">
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.admin_id"
              :options="admins"
              label="full_name"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label"> المديرين </label>
          </div>
        </div>
        <div class="date col-sm-3 col-md-4">
          <div class="select-wrapper">
            <div class="input_wrapper top_label">
              <label for="" class="form-label">
                {{ from_title }}
              </label>
              <v-menu
                ref="dateStartModal"
                v-model="dateStartModal"
                :close-on-content-click="false"
                :return-value.sync="frmData.dateStart"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- multiple
                  chips
                  small-chips -->
                  <v-combobox
                    v-model="frmData.dateStart"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-combobox>
                </template>
                <!-- multiple -->
                <v-date-picker
                  @input="
                    getResult();
                    dateStartModal = false;
                    $refs.dateStartModal.save(frmData.dateStart);
                  "
                  v-model="frmData.dateStart"
                  no-title
                  scrollable
                  :max="maxDate"
                >
                  <v-btn
                    text
                    color="primary"
                    @click="
                      frmData.dateStart = '';
                      $refs.dateStartModal.save(frmData.dateStart);
                      dateStartModal = false;
                      getResult();
                    "
                  >
                    الغاء
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </div>
        <div class="date col-sm-3 col-md-4">
          <div class="select-wrapper">
            <div class="input_wrapper top_label">
              <label for="" class="form-label"> {{ to_title }} </label>
              <v-menu
                ref="dateEndModal"
                v-model="dateEndModal"
                :close-on-content-click="false"
                :return-value.sync="frmData.dateEnd"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- multiple
                  small-chips -->
                  <v-combobox
                    v-model="frmData.dateEnd"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-combobox>
                </template>
                <!-- multiple -->
                <v-date-picker
                  @input="
                    getResult();
                    dateEndModal = false;
                    $refs.dateEndModal.save(frmData.dateEnd);
                  "
                  v-model="frmData.dateEnd"
                  no-title
                  scrollable
                  :min="frmData.dateStart"
                  :max="maxDate"
                >
                  <v-btn
                    text
                    color="primary"
                    @click="
                      frmData.dateEnd = '';
                      $refs.dateEndModal.save(frmData.dateEnd);
                      dateEndModal = false;
                      getResult();
                    "
                  >
                    الغاء
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </div>
        <div class="col-sm-3 col-md-4">
          <div class="reset_button_container">
            <button type="button" class="reset_button" @click="restFileds">
              <i class="fas fa-redo-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    dateStart: {
      type: Boolean,
      default: false,
    },
    startAt: {
      type: Boolean,
      default: false,
    },
    dateEnd: {
      type: Boolean,
      default: false,
    },
    endAt: {
      type: Boolean,
      default: false,
    },

    orderStatus: {
      type: Boolean,
      default: false,
    },

    from_title: {
      type: String,
      required: false,
      default: "من",
    },
    to_title: {
      type: String,
      required: false,
      default: "الي",
    },
    reportType: {
      type: String,
      required: true,
    },
    withSearch: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dateStartModal: false,
      dateEndModal: false,
      dateMadeModal: false,
      frmData: {
        admin_id: null,
        searchInput: null,
        number_seats: null,
        number_doors: null,
        dateStart: null,
        dateEnd: null,
        dateMade: null,
        user: null,
        brand: null,
        model: null,
        order_status: null,
        provider: null,
        order_type: {
          text: "توصيلات",
          value: "report_delivery",
        },
        user_type: {
          text: "عميل",
          value: "client",
        },
        type: {
          text: "سحب",
          value: "withdrawal",
        },
        deposit_type: {
          value: "from_admin",
          text: "من الادمن",
        },
        report_status: {
          value: "driver_finished",
          text: "تم التوصيل من السائق",
        },
        report_cancel_order_status: {
          value: "client_cancel",
          text: "ملغية من العميل",
        },
        report_cancel_order_reason: null,
      },
      userKey: {
        input: "",
        keyword: "",
      },
      userTypes: [
        {
          value: "client",
          text: "عميل",
        },
        {
          value: "restaurant",
          text: "مطعم",
        },
        {
          value: "driver",
          text: "سائق",
        },
      ],
      order_types: [
        {
          text: "توصيلات",
          value: "report_delivery",
        },
        {
          text: "طرود",
          value: "report_package",
        },
      ],
      order_statuses: [
        {
          text: "الطلبات الجديدة",
          value: "pending",
        },
        { text: "المقبولة من السائق", value: "driver_accept" },
        // {
        //   text: "المرفوضة من السائق",
        //   value: "driver_rejected",
        // },
        {
          text: "بدأت  من السائق",
          value: "driver_start_order",
        },
        {
          text: "انهي السائق توصيلها",
          value: "driver_finished",
        },
        {
          text: "ملغية من قبل العميل",
          value: "client_cancel",
        },
        // {
        //   text: "ملغية من قبل السائق",
        //   value: "driver_cancel",
        // },
      ],
      admins: [],
      types: [
        {
          text: "سحب",
          value: "withdrawal",
        },
        {
          text: "ايداع",
          value: "deposit",
        },
      ],
      deposit_types: [
        {
          value: "from_admin",
          text: "من الادمن",
        },
        {
          value: "from_user",
          text: "من المحفظة",
        },
      ],
      reportStatus: [
        {
          value: "driver_finished",
          text: "تم التوصيل من السائق",
        },
        {
          value: "client_cancel",
          text: "ملغية من العميل",
        },
        {
          value: "admin_cancel",
          text: "ملغية من الادمن",
        },
      ],
      cancelOrderStatus: [
        {
          value: "client_cancel",
          text: "ملغية من العميل",
        },
        {
          value: "admin_cancel",
          text: "ملغية من الادمن",
        },
      ],
      reportCancelOrderReasons: [],
    };
  },

  watch: {
    ["frmData.searchInput"](newVal) {
      if (newVal) {
        this.frmData.searchInput = newVal;

        this.get_filterd_users();
      }
    },
    ["frmData.dateStart"](newVal) {
      if (newVal) {
        this.getResult();
      }
    },
    ["frmData.dateEnd"](newVal) {
      if (newVal) {
        this.getResult();
      }
    },
    ["frmData.order_type"](newVal) {
      this.frmData.order_status = null;
      if (newVal.value == "report_delivery") {
        this.order_statuses = [
          {
            text: "الطلبات الجديدة",
            value: "pending",
          },
          { text: "المقبولة من السائق", value: "driver_accept" },
          {
            text: "المرفوضة من السائق",
            value: "driver_rejected",
          },
          {
            text: "بدأت  من السائق",
            value: "driver_start_order",
          },
          {
            text: "انهي السائق توصيلها",
            value: "driver_finished_delivery",
          },
          {
            text: "ملغية من قبل العميل",
            value: "client_cancel",
          },
          {
            text: "ملغية من قبل السائق",
            value: "driver_cancel",
          },
        ];
      }
      if (newVal.value == "report_package") {
        this.order_statuses = [
          {
            text: "الطلبات الجديدة",
            value: "pending",
          },
          { text: "المقبولة من السائق", value: "driver_accept" },
          {
            text: "المرفوضة من السائق",
            value: "driver_rejected",
          },
          {
            text: "بدأت  من السائق",
            value: "driver_start_order",
          },
          {
            text: "انهي السائق توصيلها",
            value: "driver_finished_package",
          },
          {
            text: "ملغية من قبل العميل",
            value: "client_cancel",
          },
        ];
      }
      this.getResult();
    },

    // else {
    //   this.modelsOptions = [];
    //   this.frmData.model = null;
    // }
    // console.log("called");

    // modelsOptions(value) {
    //   if (!value.includes(this.model)) {
    //     this.frmData.model = null;
    //   }
    // },
  },
  mounted() {
    if (this.$route.query.keyword) {
      this.frmData.searchInput = this.$route.query.keyword;
      // this.getResult()
    }
    if (this.brands) {
      this.$globalService.getBrands().then((res) => (this.brandsOptions = res));
    }
    this.getAdmins();
    this.getCancelOrderReasons();
  },
  methods: {
    restFileds() {
      this.frmData = {
        searchInput: null,
        number_seats: null,
        number_doors: null,
        dateStart: null,
        dateEnd: null,
        dateMade: null,
        user: null,
        brand: null,
        model: null,
        order_status: null,
        provider: null,
        order_type: {
          text: "توصيلات",
          value: "report_delivery",
        },
        user_type: {
          text: "عميل",
          value: "client",
        },
      };
      this.getResult();
    },
    getResult() {
      this.$emit("getResult", this.frmData);
    },

    setKeyWord(event, query) {
      console.log(event);
      this.frmData.searchInput = event;

      this.$router
        .push({
          query: Object.assign({}, this.$route.query, {
            page: 1,
            [query]: event,
          }),
        })
        .catch(() => {});
    },
    getAdmins() {
      this.$axios({
        method: "GET",
        url: "admin_not_paginated",
      }).then((res) => {
        this.admins = res.data.data;
      });
    },
    getCancelOrderReasons() {
      this.$axios({
        method: "GET",
        url: "cancel_reason_not_paginated?reason_type=cancel",
      }).then((res) => {
        this.reportCancelOrderReasons = res.data.data;
      });
    },
  },
  // watch: {
  //   ["$route.query.keyword"](newVal) {
  //     this.frmData.searchInput = newVal;
  //     this.getResult();
  //   },
  // },

  computed: {
    payment_types() {
      return [
        {
          text: "نقدي",
          value: "cash",
        },
        {
          text: "اون لاين",
          value: "online",
        },
      ];
    },
    maxDate() {
      const date = new Date();
      return date.toISOString();
    },
  },
};
</script>

<style lang="scss" scoped>
.main-filter {
  .frm-controls {
    display: flex;
    flex-wrap: wrap;

    .form-control {
      // background: var(--mainBgColor) !important;
      // color: var(--blackColor) !important;
      border: none;
      height: 45px;
    }

    .v-text-field {
      padding-top: 0;
      margin-top: 0;
      // background: var(--mainBgColor) !important;
      border-radius: 0.375rem;
      align-items: center;
    }
    .v-autocomplete.v-input > .v-input__control > .v-input__slot::before {
      display: none;
    }
    .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }
  }
  form {
    .form-control {
      width: 100% !important;
    }
    .form-action {
      width: 100% !important;
    }
    min-height: 55px;
  }

  .search-icon {
    color: var(--blackColor) !important;
  }
  .v-text-field__details {
    display: none;
  }

  .v-input__slot {
    margin: 0;
    height: 45px !important;
    box-shadow: none !important;
  }
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: auto !important;
  }
  .row {
    margin: 0;
    > div {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
  }

  a.btn {
    background: var(--mainColor-2) !important;
    color: #fff !important;
    height: 45px;
    font-size: 16px;
    line-height: 30px;
  }
  .multiselect__tags {
    height: 45px;
    text-align: start;

    border: none;
    .multiselect__tags-wrap {
      display: flex;
      overflow-x: auto;
    }

    .multiselect__element {
      text-align: start !important;
    }
    .multiselect__single {
      background: var(--mainBgColor);
    }
  }
  .multiselect__content-wrapper {
    background: var(--mainBgColor) !important;
    border: none;
  }

  .v-input input {
    padding: 6px 12px;
    & ~ label {
      right: 6px !important;
    }
  }

  .v-text-field
    > .v-input__control
    > .v-input__slot
    > .v-text-field__slot
    label {
    right: 6px !important;
  }

  .input_wrapper {
    margin-block: 10px !important;
  }
}

.reset_button_container {
  padding: 0.5rem;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  .reset_button {
    font-size: 1.2rem;
    height: 100%;
    width: 100%;
    color: white;
    // display: flex;
    // justify-content: center;
    // // align-items: flex-end;
    background: var(--mainColor-2);
    border: 1px solid var(--mainColor-2);
    border-radius: 30px;
    transition: all 0.3s;
    &:hover {
      color: var(--mainColor-2);
      background: white;
    }
  }
}
</style>
